import { URI_TARIFF_PLAN } from '@/config/config';

export default async ({ rootState }, payload) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };

  const response = await fetch(
    `${URI_TARIFF_PLAN}relate-tariff-schedule/client`,
    opts,
  );
  const jsonResult = await response.json();

  if (jsonResult.errors) {
    return Promise.reject(jsonResult.errors);
  }

  return jsonResult;
};
